import { get } from 'lodash-es';

export const isAuthenticatedSelector = (state) => get(state, ['auth', 'isAuthenticated']);
export const userSelector = (state) => get(state, ['auth', 'user']);
export const authErrorSelector = (state) => get(state, ['auth', 'error']);
